export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CoreForm.vue?vue&type=template&id=59ca556e&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/CoreForm.vue?vue&type=template&id=59ca556e&
// module id = 1075
// module chunks = 0